import styled from 'styled-components'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(p) => p.theme['color-text-3']};
  font-size: 14px;
  height: calc(100% - 20px);
  min-height: 128px;
  padding: 20px;
  max-width: 400px;
  text-align: center;
  > div {
    display: flex;
    flex-direction: column;
  }
`
export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

export const ButtonLink = styled.a`
  color: ${(p) => p.theme['gray-9']};
  background-color: ${(p) => p.theme['theme-5']};
  display: flex;
  height: 28px;
  line-height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
`

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(p) => p.theme['color-text-3']};
  font-size: 14px;
  min-height: 128px;
  padding: 20px;
  max-width: 400px;
  text-align: center;
  background-color: ${(p) => p.theme['gray-1']};
`

export const TipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(p) => p.theme['color-text-3']};
  font-size: 16px;
  min-height: 80px;
  padding: 20px;
  max-width: 400px;
  text-align: center;
`
